var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharedFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.916,6H12.33L9.623,3.293C9.436,3.105,9.181,3,8.916,3h-4c-1.654,0-3,1.346-3,3v11c0,1.654,1.346,3,3,3h7.667v-2H4.916 c-0.551,0-1-0.448-1-1V6c0-0.551,0.449-1,1-1h3.586l2.707,2.707C11.396,7.895,11.651,8,11.916,8h7c0.552,0,1,0.449,1,1v2.543h2V9 C21.916,7.346,20.57,6,18.916,6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.168,11.884 16.283,11.884 16.283,14.688 13.456,14.688 13.456,16.625 16.283,16.625 16.283,19.431  18.168,19.431 18.168,16.625 21.003,16.625 21.003,14.688 18.168,14.688  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedFolder);
export default __webpack_public_path__ + "static/media/shared-folder.55dee15fed90f7a9adcec0b557f4414d.svg";
export { ForwardRef as ReactComponent };